// datetime-local expects the browser's wall clock, not a UTC ISO string. Using
// toISOString().slice(0,16) here moved Qatar deadlines three hours on every save.
export function toDateTimeLocal(value) {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const pad = number => String(number).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function schedulePatch(draft, baseline) {
  const patch = {};
  for (const key of ['openDate', 'dueDate', 'closeDate']) {
    if (draft[key] !== toDateTimeLocal(baseline[key])) {
      patch[key] = draft[key] ? new Date(draft[key]).toISOString() : null;
    }
  }
  if (draft.autoCloseOnDeadline !== (baseline.autoCloseOnDeadline ?? true)) {
    patch.autoCloseOnDeadline = draft.autoCloseOnDeadline;
  }
  const grace = Number.parseInt(draft.gracePeriodMinutes, 10) || 0;
  if (grace !== (baseline.gracePeriodMinutes ?? 0)) patch.gracePeriodMinutes = grace;
  // An untouched date is omitted: preserve seconds/milliseconds and changes
  // made by another operator while this form was open.
  if (Object.keys(patch).length) patch.expectedLifecycleRevision = baseline.lifecycleRevision || 0;
  return patch;
}
